import { throttle } from 'lodash';
import { useGlobalScrollLock } from '@shared/composables/lockGlobalScroll/lockGlobalScroll';

const { lockScroll, unlockScroll, scrollWidth } = useGlobalScrollLock();

const Dropdowns = {
  namespaced: true,

  state: {
    //Храню имена открытых dropdown и popup
    list: [],
  },

  actions: {
    //Регистрация нового попапа
    addNewDropdown({ commit }, dropdownName) {
      commit('ADD_NEW_DROPDOWN', dropdownName);
      lockScroll();
    },
    //Удаляю последний попап в списке
    removeLastDropdown: throttle(function({ commit, state }) {
      commit('REMOVE_LAST_DROPDOWN');
      if (state.list.length === 0) {
        unlockScroll();
      }
    }, 150),
    //Удаляю конкретный попап
    removeTheDropdown({ commit, state }, dropdownName) {
      commit('REMOVE_THE_DROPDOWN', dropdownName);
      if (state.list.length === 0) {
        unlockScroll();
      }
    },
    //Удаляю все попапы
    clearAllDropdowns({ commit }) {
      commit('CLEAR_LIST');
      unlockScroll();
    },
  },

  mutations: {
    //Добавляю новый открытый dropdown в список, если такого еще нет в списке открытых
    ADD_NEW_DROPDOWN(state, dropdownName) {
      const isDropdownInList = state.list.includes(dropdownName);
      if (isDropdownInList) return;
      state.list.push(dropdownName);
    },
    //Убираю последний dropdown или popup из списка
    REMOVE_LAST_DROPDOWN(state) {
      if (state.list.length <= 0) return;
      state.list.pop();
    },
    //Убираю определенный dropdown или popup из списка
    REMOVE_THE_DROPDOWN(state, dropdownName) {
      state.list = state.list.filter(item => item !== dropdownName);
    },
    //Скрыть все дропдауны
    CLEAR_LIST(state) {
      state.list = [];
    },
  },

  getters:{
    //Открыт ли дропдаун?
    isOpenedDropdown: (state) => {
      return state.list.length > 0;
    },
    //Проверяем, присутствует ли этот дропдаун в списке?
    isInList: (state) => (dropdownName) => {
      return state.list.includes(dropdownName);
    },
    //Текущая ширина скроллбара
    scrollWidth: () => {
      return scrollWidth.value;
    }
  }
}

export default Dropdowns;